import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";
import { loader } from "./modules/loader";

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
});
export default new Vuex.Store({
  modules: {
    loader,
  },

  state: {
    permissions: null,
    batchImages: null,
    expiryDate: null,
    creationDate: null,
    token: null,
    userType: null,
    imagesData: null,
  },
  mutations: {
    ["username"](state, payload) {
      state.username = payload;
    },

    ["imagesData"](state, payload) {
      state.imagesData = payload;
    },
    ["formData"](state, payload) {
      state.formData = payload;
    },

    ["login"](state, payload) {
      for (var element of Object.keys(payload)) {
        state[element] = payload[element];
      }
    },
    ["permissions"](state, payload) {
      if (!state.permissions) {
        state.permissions = {};
      }
      for (var element of Object.keys(payload)) {
        state.permissions[element] = payload[element];
      }
    },
    ["logout"](state) {
      state.id = null;
      state.batchImages = null;
      state.token = null;
      state.username = null;
      state.permissions = {};
      state.userType = null;
      state.userId = null;
      state.creationDate = null;
    },

    ["saveBatchImages"](state, payload) {
      state.batchImages = payload;
    },
    // ["updateBatchImages"](state, payload) {
    //   var index = state.batchImages.findIndex(
    //     (image) => image.id == payload.id
    //   );
    //   if (index != -1) {
    //     state.batchImages[index] = payload;
    //   } else {
    //     state.batchImages.push(payload);
    //   }
    // },
  },
  actions: {},
  plugins: [vuexLocal.plugin],
});
